import ParagraphAboutUs from '../implementations/Paragraph/AboutUs';
import ParagraphAccordion from '../implementations/Paragraph/Accordion';
import ParagraphAccordionRow from '../implementations/Paragraph/Accordion/Row';
import ParagraphBlockReference from '../implementations/Paragraph/BlockReference';
import ParagraphButton from '../implementations/Paragraph/Button';
import ParagraphColleague from '../implementations/Paragraph/Colleague';
import ParagraphContact from '../implementations/Paragraph/Contact';
import ParagraphGrowthPath from '../implementations/Paragraph/GrowthPath';
import ParagraphGrowthPathItem from '../implementations/Paragraph/GrowthPath/Item';
import ParagraphQuote from '../implementations/Paragraph/Quote';
import ParagraphText from '../implementations/Paragraph/Text';
import ParagraphTextImage from '../implementations/Paragraph/TextImage';
import ParagraphVideo from '../implementations/Paragraph/Video';
import ParagraphCTAReference from '../implementations/Paragraph/CTAReference';
import ParagraphMarketoForm from '../implementations/Paragraph/MarketoForm';
import ParagraphDownload from '../implementations/Paragraph/Download';
import ParagraphHighlightedEvents from '../implementations/Paragraph/HighlightedEvents';
import ParagraphAllEvents from '../implementations/Paragraph/AllEvents';
import ParagraphImage from '../implementations/Paragraph/Image';
import ParagraphVacanciesOverview from '../implementations/Paragraph/VacanciesOverview';
import ParagraphInternshipVacanciesOverview from '../implementations/Paragraph/InternshipVacanciesOverview';
import VacancyTeasers from '../implementations/Views/Vacancies/Teasers';

const mappers = {
  about_us: ParagraphAboutUs,
  accordion: ParagraphAccordion,
  accordion_row: ParagraphAccordionRow,
  block_reference: ParagraphBlockReference,
  button: ParagraphButton,
  colleague: ParagraphColleague,
  contact: ParagraphContact,
  growth_path: ParagraphGrowthPath,
  growth_path_item: ParagraphGrowthPathItem,
  image: ParagraphImage,
  quote: ParagraphQuote,
  quote_block: ParagraphQuote,
  text: ParagraphText,
  text_image: ParagraphTextImage,
  video: ParagraphVideo,
  marketo_form: ParagraphMarketoForm,
  cta_reference: ParagraphCTAReference,
  download: ParagraphDownload,
  highlighted_events: ParagraphHighlightedEvents,
  all_events: ParagraphAllEvents,
  vacancies_overview: ParagraphVacanciesOverview,
  internship_vacancies_overview: ParagraphInternshipVacanciesOverview,
  vacancy_teasers: VacancyTeasers,
};

export default mappers;
